import React from 'react';
import 'styles/settings/fonts.css';
import 'styles/styles.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from 'pages/home';
import Preloader from 'pages/preloader';
import ContactModal from 'components/generals/modal/contact';
import ContactForm from 'components/generals/forms/contact';
import { useLocation } from 'react-router-dom';
import 'animate.css';
import './i18n';
function App() {
    const { pathname } = useLocation();
    console.log(pathname);
    return (
        <>
            <Preloader />

            {/* <Routes>
                <Route path="/contacto" element={<ContactModal />} />
            </Routes> */}
        </>
    );
}

export default App;
